import fetch from 'utils/fetch';
import { createAction } from 'redux-actions';

export const requestFormAction = createAction('REQUEST_FORM');
export const receiveFormAction = createAction('RECEIVE_FORM');

export const updateDataAction = createAction('UPDATE_FIELD');

function fetchForm(id) {
  return dispatch => {
    dispatch(requestFormAction());
    fetch(`/pco-manager/aast/cases/contract/${id}/renew.json`)
      .then(r => r.json())
      .then(nodes => {
        dispatch(receiveFormAction(nodes));
      });
  };
}

function shouldFetchForm(id, state) {
  const form = state.form;

  if (form.id === undefined && id > 0 && !form.isFetching) {
    return true;
  }

  return false;
}

export const fetchFormIfNeeded = id => (dispatch, getState) => {
  const state = getState();
  if (shouldFetchForm(id, state)) {
    dispatch(fetchForm(id));
  }
};

export const updateData = (propName, propValue) => (dispatch, getState) => {
  dispatch(updateDataAction({ propName, propValue }));
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/renew/actions/form.js